<template>
    <div class="col p-0" id="discussion-panel">
        <div class="d-flex justify-content-between bg-secondary text-light p-2 align-items-center">
            <div>
                <bs-action :icon="['fas', 'times']" class="btn-secure mr-2" @click="chatToggle"></bs-action>
                <bs-action :icon="['fal', 'window-restore']" class="btn-secure" @click="chatTypeToggle" v-tooltip.top="$t('messages.discussion_toggle')"></bs-action>
            </div>
            <div class="d-flex align-items-center drag-handle">
                <small><strong class="text-uppercase" style="letter-spacing:0.1rem">{{ $t('labels.discussions') }}</strong></small>
                <avatar class="ml-2" />
            </div>
        </div>
        <ul id="discussion-nav" class="nav justify-content-between bg-secondary drag-handle">
            <li class="nav-item">
                <small><strong class="nav-link text-light text-uppercase" :class="activeType === 'Contact' ? 'active' : ''" @click="swapDiscussion('Contact')">{{ $t('labels.contacts') }}</strong></small>
            </li>
            <li class="nav-item">
                <small><strong class="nav-link text-light text-uppercase" :class="activeType === 'Open' ? 'active' : ''" @click="swapDiscussion('Open')">{{ $t('labels.open') }}</strong></small>
            </li>
        </ul>
        <div id="discussions-nav" class="bg-primary py-2">
            <ul class="nav flex-column" v-if="activeType === 'Contact'">
                <li class="nav-item" @click="create()">
                    <span class="nav-link text-light py-1">
                        <bs-badge class="badge-secondary"><fa-icon :icon="['fal', 'plus']"></fa-icon></bs-badge>
                        {{ $t('labels.action_resource', { action: $t('labels.new'), resource: $tc('labels.text_message', 1) }) }}
                    </span>
                </li>
                <li class="nav-item" v-for="d in discussions.data" :key="'d' + d.id">
                    <span class="nav-link text-light py-1 d-flex justify-content-between align-items-center" :class="d.id === chat.id ? 'active' : ''" @click="chatActive(d)" style="line-height:1em">
                        <span class="d-block">
                          <span>{{ _.truncate(d.label, { 'length': 34 }) }}</span><br>
                          <small class="text-muted"><b>{{ d.updated_at | luxon:diffForHumans }}</b></small>
                        </span>
                        <span class="badge badge-success" v-if="d.unread">{{ d.unread }}</span>
                    </span>
                </li>
            </ul>
            <ul class="nav flex-column" v-if="activeType === 'Open'">
                <li class="nav-item" v-for="d in openDiscussions" :key="'od' + d.id">
                    <span class="nav-link text-light py-1 d-flex justify-content-between" :class="d.id === chat.id ? 'active' : ''">
                        <span @click="chatActive(d)">{{ _.truncate(d.label, { 'length': 34 }) }}</span>
                        <bs-action :icon="['fas', 'times']" class="btn-outline-light" v-tooltip.bottom="$t('messages.discussion_close')" @click="clearDiscussion(d.id)"></bs-action>
                    </span>
                </li>
            </ul>
        </div>
        <pagination id="discussion-pagination" class="bg-secondary" :data="discussions" @pushPage="index" v-if="activeType === 'Account'"></pagination>

        <bs-modal :name="'create-' + $options.name" :label="$t('labels.action_resource', { action: $t('labels.create'), resource: $t('labels.discussion', {}, 1) })">
            <bs-form :submit="$t('labels.submit')" @submit="submit">
                <template>
                  <multiselect class="mb-3" v-model="resource.contact" :options="contacts" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="false" :placeholder="$t('labels.choose_option', { resource: $t('labels.contact') })" label="name" track-by="id" />
                </template>
            </bs-form>
        </bs-modal>

    </div>

</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Discussions',
  components: {
    Multiselect
  },
  data () {
    return {
      activeType: 'Contact',
      resource: {
        contact: null
      }
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      chatState: state => state.chatState,
      contacts: state => state.allContacts.data,
      discussions: state => state.discussions.discussions,
      openDiscussions: state => state.discussions.localDiscussions,
      resourceState: state => state.discussionsState,
      chat: state => state.chatActive
    })
  },
  mounted () {
    this.index()
    this.$store.dispatch('index', { collection: 'allContacts' })
  },
  watch: {
    chat (discussion) {
      this.$emit('openDiscussion', discussion)
    }
  },
  methods: {
    ...mapMutations([
      'chatActive',
      'chatToggle',
      'chatTypeToggle'
    ]),
    swapDiscussion (type) {
      if (this.activeType !== type) {
        this.activeType = type
      }
    },
    clearDiscussion (discussion) {
      this.$store.commit('clearDiscussion', discussion)
    },
    index (page, count) {
      if (page) this.$store.commit('pushState', { view: this.$options.name, key: 'page', data: page })
      else page = this.resourceState.page
      if (count) this.$store.commit('pushState', { view: this.$options.name, key: 'tableRows', data: count })
      else count = this.resourceState.tableRows
      this.loading = true
      this.$store.dispatch('indexDiscussions', {
        params: { page: page, count: count }
      }).then(() => {
        this.loading = false
        this.panelWidth = 600
      })
    },
    closeDiscussion () {
      this.openDiscussion = null
      this.panelWidth = 300
      this.$modal.hide('appChat')
      this.$modal.show('appChat')
    },
    initializeSize () {
      this.$refs.appChat.setInitialSize()
    },
    create () {
      this.$store.commit('axiosError', null)
      this.$root.clearData(this.resource)
      this.$modal.show('create-' + this.$options.name)
    },
    submit () {
      this.$store.dispatch('store', { collection: this.$options.name, resource: this.resource }).then((response) => {
        this.$modal.hide('create-' + this.$options.name)
        this.chatActive(response.data.data)
        this.index(1)
      })
    }
  }
}
</script>

<style lang="scss">
    #discussion-panel {
        position: relative;
        max-width: 100%;

        #discussion-pagination {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
        }
    }

    #discussions-nav {
        position: absolute;
        top: 84px;
        bottom: 52px;
        left: 0;
        right: 0;
        overflow-y: scroll;
        font-weight: 400;

        .nav-link {
            cursor: pointer;
            font-size: 0.875rem;

            &:hover, &.active {
                background: var(--secondary)
            }
        }

        &::-webkit-scrollbar {
            width: 4px;
            height: 10px;
        }

        &::-webkit-scrollbar-track {
            border-radius: 10px;
            border: none;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 3px;
            background: var(--gray);
        }
    }

    @media (min-width: 768px) {
        #discussion-panel {
            max-width: 300px;
        }

        .chat-fixed {
            #discussion-panel {
                max-width: 100%;
            }
        }
    }
</style>
